export const search = 'Buscar';
export const reservations = 'Reservaciones';
export const logOut = 'Cerrar sesión';
